import { createAction, props } from '@ngrx/store';
import { Opportunity } from '@shared/models/opportunity';

export const loadOpportunity = createAction('[Opportunities] Load Opportunity', props<{ opportunityId: number }>());

export const loadOpportunitySuccess = createAction(
  '[Opportunities] Load Opportunity Success',
  props<{ opportunity: Opportunity }>(),
);

export const loadOpportunityFailure = createAction('[Opportunities] Load Opportunity Failure', props<{ error: any }>());
